import script from "./comp_elemento_lista_restaurantes.vue?vue&type=script&setup=true&lang=js"
export * from "./comp_elemento_lista_restaurantes.vue?vue&type=script&setup=true&lang=js"

import "./comp_elemento_lista_restaurantes.vue?vue&type=style&index=0&id=7e9b6254&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e9b6254"]])

export default __exports__